import React from 'react';
import Header from './../components/Header';
import { Container, Row, Col, Table } from 'react-bootstrap';

const CockPage: React.FC = () => {
  return (
    <div id="page-container">
      <div id="content-wrap">
        <Header />

        <Container className="mt-3 mb-3">
          <h4>Snowpeak BWF Tournament Shuttlecock (C1101)</h4>

          <Row className="mt-4">
            <Col md="6">
              <img
                src="/images/shuttle.jpg"
                alt="Snowpeak C1101 Shuttlecock"
                className="img-fluid"
              />
            </Col>
            <Col md="6" className="mt-3 mt-md-0">
              <p>
                The Snowpeak C1101 is a high quality professional feather shuttlecock designed for
                tournament level badminton play. It is manufactured using premium goose feathers and
                a high quality sandwich cork base to ensure excellent flight stability, durability,
                and consistent performance.
              </p>
              <p>
                This shuttlecock is comparable in performance to well known professional models such
                as Yonex Aerosensa 40 (AS-40), Lingmei 90, and Li-Ning G900, making it an excellent
                choice for competitive players, clubs, and tournaments seeking reliable and consistent
                shuttle performance.
              </p>
            </Col>
          </Row>

          <h5 className="mt-4">Technical Specifications</h5>
          <Table striped bordered className="mt-2">
            <tbody>
              <tr>
                <td><strong>Model</strong></td>
                <td>Snowpeak C1101</td>
              </tr>
              <tr>
                <td><strong>Type</strong></td>
                <td>Professional feather shuttlecock</td>
              </tr>
              <tr>
                <td><strong>Feather</strong></td>
                <td>Selected natural goose feathers</td>
              </tr>
              <tr>
                <td><strong>Cork</strong></td>
                <td>Three layer sandwich cork base</td>
              </tr>
              <tr>
                <td><strong>Speed</strong></td>
                <td>77 (moderate speed, suitable for most indoor halls in Europe)</td>
              </tr>
              <tr>
                <td><strong>Quantity</strong></td>
                <td>12 shuttlecocks per tube</td>
              </tr>
              <tr>
                <td><strong>Origin</strong></td>
                <td>Made in China</td>
              </tr>
              <tr>
                <td><strong>Certification</strong></td>
                <td>BWF Approved</td>
              </tr>
            </tbody>
          </Table>
        </Container>
      </div>

      <footer id="footer" className="mt-5">
        <Container>
          <Row>
            <Col>Developed by Faisel Kachappilly &copy; {new Date().getFullYear()}. All rights reserved
              <span> |</span>
              <a href="http://www.webzenz.ch/" target="_blank" rel="noopener noreferrer"> Webagentur</a></Col>
          </Row>
        </Container>
      </footer>
    </div>
  );
};

export default CockPage;
